{
  "version": 1,
  "asset_id": "a922248d-832c-4f8d-9a79-b173e726f97c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a922248d-832c-4f8d-9a79-b173e726f97c/loc-georgetown-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a922248d-832c-4f8d-9a79-b173e726f97c/loc-georgetown-1280.avif",
  "original_filename": "loc-georgetown-1280.avif",
  "size": 93834,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:27Z"
}
